import React, { useState, useRef } from 'react';
import { Row, Col, Card, CardBody, CardHeader, Label, Input, Button, Table, Modal, ModalHeader, ModalBody, ModalFooter, Spinner, Collapse, FormGroup } from 'reactstrap';
import axios from 'axios';
import toast, { Toaster } from 'react-hot-toast';
import { FaUpload, FaTrash, FaChevronUp, FaChevronDown, FaShareAlt, FaEdit } from 'react-icons/fa';
import uuid from 'react-uuid';
import Validate from '../Validate/Validate';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { ToastContainer, toast as toastytoast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import moment from "moment";
import { Tooltip as ReactTooltip } from "react-tooltip";

const Reporting = ({ reportType1, handleReportTypeChange, showEnvironmentSouthland,showEnvironmentCanterbury,handleSetFEPOnly,fepOnly,farmId, reportDocumentList, ActionDueList, exportSummaryToPdf, exportFEPSummaryToPdf, reportButtonVisible, generateReport, generateFEPReport, autoUploadSaving, exportAutoUploadToPdf }) => {
    const [farmName, setFarmName] = useState(JSON.parse(localStorage.getItem("defaultFarmName"))); const [farmUniqueId, setFarmUniqueId] = useState(JSON.parse(localStorage.getItem("defaultFarmUniqueId")));
    const [isOpen, setIsOpen] = useState(true); 
    const [isIconUp, setIsIconUp] = useState(true);
    const toggle = () => {
        setIsOpen(!isOpen)
        setIsIconUp(!isIconUp)
    };
    const [reportDocumentItem, setReportDocumentItem] = useState(reportDocumentList);
    const roleName = localStorage.getItem("roleName");
    const saveRightsForNonItemFieldsAndTables = localStorage.getItem("saveRightsForNonItemFieldsAndTables");
    const [reportType, setReportType] = useState(1); const [userId, setUserId] = useState(localStorage.getItem("loggedInUserId")); const [saving, setSaving] = useState(false);
    const [uploadingDocument, setUploadingDocument] = useState(false); 
    
    const [reportPopup, setReportPopup] = useState({
        showReportPopup: false, reportTypePopup: 1, notePopup: '', showReportingUser: false, reportingUser: '', reportingUserLabel: ''
        , certificationOutcome: 'Certified', nextCertificationDue: null, auditGrade: '', nextAuditDue: null, type: '', id: 0, noConflictOfIntrest:false
    });
    const [autoUploadPopup, setAutoUploadPopup] = useState({ showAutoUploadPopup: false, reportTypePopup: 1, notePopup: '', showReportingUser: false, reportingUser: '', reportingUserLabel: '' });
    const [sharePopup, setSharePopup] = useState({ showSharePopup: false, reportRelativePath: '', EmailAddress: '', itemId: 0,isExpired:false,id:0 });
    const [itemDeletePopup, setItemDeletePopup] = useState({ showItemDeletePopup: false, itemId: 0 });
    const [autoUploadPopupModal, setAutoUploadPopupModal] = useState({ showAutoUploadPopup: false });
    const [sending, setSending] = useState(false);
    const [reportDate, setReportDate] = useState(null);
    const [formErrors, setFormErrors] = useState({});    
    function handleReportPopupChange(event) {
        const { name, value, checked, type } = event.target;
        if (name == 'reportTypePopup') {
            if (value == '2') {
                setReportPopup({ ...reportPopup, showReportingUser: true, reportingUserLabel: 'Certifier Name and ID', reportingUser: '', [name]: type == 'checkbox' ? checked : value, type: 'Certifier' });
            }
            else if (value == '3') {
                setReportPopup({ ...reportPopup, showReportingUser: true, reportingUserLabel: 'Auditor Name and ID', reportingUser: '', [name]: type == 'checkbox' ? checked : value, type: 'Auditor' });
            }
            else {
                setReportPopup({ ...reportPopup, [name]: type == 'checkbox' ? checked : value });
            }
        }
        else {
            setReportPopup({ ...reportPopup, [name]: type == 'checkbox' ? checked : value });
        }
    }
    function handleAutoUploadPopupChange(event) {
        const { name, value, checked, type } = event.target;
        if (name == 'reportTypePopup') {
            if (value == '2') {
                setAutoUploadPopup({ ...autoUploadPopup, showReportingUser: true, reportingUserLabel: 'Certifier', reportingUser: '', [name]: type == 'checkbox' ? checked : value });
            }
            else if (value == '3') {
                setAutoUploadPopup({ ...autoUploadPopup, showReportingUser: true, reportingUserLabel: 'Auditor', reportingUser: '', [name]: type == 'checkbox' ? checked : value });
            }
            else {
                setAutoUploadPopup({ ...autoUploadPopup, [name]: type == 'checkbox' ? checked : value });
            }
        }
        else {
            setAutoUploadPopup({ ...autoUploadPopup, [name]: type == 'checkbox' ? checked : value });
        }
    }
    function handleSharePopupChange(event) {
        const { name, value, checked, type } = event.target;
        setSharePopup({ ...sharePopup, [name]: type == 'checkbox' ? checked : value });
    }
    function handleReportPopupClose() {
        setReportPopup({ ...reportPopup, showReportPopup: false});
    }
    function handleAutoUploadPopupClose() {
        setAutoUploadPopup({ ...autoUploadPopup, showAutoUploadPopup: false });
        window.location.reload(true);
    }
    function handleSharePopupClose() {
        setSharePopup({ ...sharePopup, showSharePopup: false, isExpired: false, id: 0 });
    }
    const handleUnshare = async() => {
        const response = await axios.get(
            '/api/Summary/UnshareReportDocument/', {
                params: { id: sharePopup.id, userId: userId }
        }
        );
        if (response.data.status) {
            setSharePopup({ ...sharePopup, showSharePopup: false, isExpired: false });
            toast.success("Document unshared!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
            window.location.reload(true);
        }
        else {
            toast.error("Error while processing the request!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
            window.location.reload(true);
            setSharePopup({ ...sharePopup, showSharePopup: false, isExpired: false });
        }
    }
    const handleSharePopupOpen = async (e,item) => {
        e.preventDefault();
        var relativePath = item.domain + 'api/FileViewer/Get?fileName=' + item.documentPhysicalName
        setSharePopup({ ...sharePopup, showSharePopup: true, reportRelativePath: relativePath, itemId: item.id, isExpired: item.isExpired,id:item.id });
    }
    const handleReportPopupOpen = async () => {
        setUploadDocumentName('');
        setUploadDocumentPhysicalFilename('');
        setUploadDocumentPhysicalFilepath('');
        setDocumentDownloadUrl('');
        setFormErrors({});
        setReportPopup({ ...reportPopup, id: 0, showReportPopup: true, reportTypePopup: 1, notePopup: '', showReportingUser: false, reportingUser: '', reportingUserLabel: '', noConflictOfIntrest:false });
    }
    const handleAutoUploadPopupOpen = async () => {
        setAutoUploadPopup({ ...autoUploadPopup, showAutoUploadPopup: true, reportTypePopup: 1, notePopup: '', showReportingUser: false, reportingUser: '', reportingUserLabel: '' });
    }
    const handleReportPopupSave = async (e) => {
        e.preventDefault();
        setFormErrors({});
        const errors = {};
        if (!reportDate) {
            errors.reportDate = "Please enter report date";
        }
        if (!uploadDocumentName) {
            errors.reportFile = "Please upload a file before saving";
        }
        setFormErrors(errors);
        if (Object.keys(errors).length == 0) {
            setSaving(true);
            var certificationOutcome = '';
            var nextCertificationDue = '';
            var auditGrade = '';
            var nextAuditDue = '';
            if (reportPopup.type == 'Certifier') {
                certificationOutcome = reportPopup.certificationOutcome;
                nextCertificationDue = getParsedDate(reportPopup.nextCertificationDue);
            }
            else if (reportPopup.type == 'Auditor') {
                auditGrade = reportPopup.auditGrade;
                nextAuditDue = getParsedDate(reportPopup.nextAuditDue);
            }
            let form = {
                id: reportPopup.id,
                DocumentName: uploadDocumentName,
                DocumentDetail: '',
                DocumentPhysicalName: uploadDocumentPhysicalFilename,
                DocumentPath: uploadDocumentPhysicalFilepath,
                Type: reportPopup.reportTypePopup,
                Notes: reportPopup.notePopup,
                Username: reportPopup.reportingUser,
                FarmId: farmId,
                UserId: userId, ReportDate: getParsedDate(reportDate),
                CertificationOutcome: certificationOutcome, NextCertificationDue: nextCertificationDue, AuditGrade: auditGrade, NextAuditDue: nextAuditDue,
                NoConflictOfIntrest: reportPopup.noConflictOfIntrest
            }
            try {
                const response = await axios.post(
                    '/api/summary/SaveReportDocument/', JSON.stringify(form),
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true
                    });
                if (response.data != null) {
                    if (response.data.status) {
                        toast.success("Document details Saved!", { duration: 5000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                        setReportDocumentItem(response.data.content);
                        setSaving(false);
                        setReportPopup({ ...reportPopup, id: 0, showReportPopup: false, reportTypePopup: 1, notePopup: '', showReportingUser: false, reportingUser: '', reportingUserLabel: '', noConflictOfIntrest:false });
                    }
                    else {
                        setSaving(false);
                        toast.error("Error while saving records!", { duration: 5000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                    }

                }
            } catch (error) {
                console.error('Error:', error);
            }
        }
        else {

        }
    }
    const [documentDownloadUrl, setDocumentDownloadUrl] = useState('');
    const [uploadDocumentName, setUploadDocumentName] = useState('');
    const [formDocumentErrors, setFormDocumentErrors] = useState({});
    const [uploadDocumentPhysicalFilename, setUploadDocumentPhysicalFilename] = useState('');
    const [uploadDocumentPhysicalFilepath, setUploadDocumentPhysicalFilepath] = useState('');
    let inputDocumentFile = '';
    const handleBtnDocumentUploadClick = async (e) => {
        e.preventDefault();
        inputDocumentFile.click();
        return false;
    }
    const handleDocumentChange = async (e) => {
        setUploadingDocument(true);
        e.preventDefault();
        setFormDocumentErrors({});
        let reader = new FileReader();
        let file = e.target.files[0];
        const errors = {};
        if ((file.size / (1024 * 1024)) > 100) {
            errors.fileError = "Sorry, uploads are restricted to a maximum of 100mb per item!";
            errors.DocumentName = "Sorry, uploads are restricted to a maximum of 100mb per item!";
        }
        setFormDocumentErrors(errors);
        if (Object.keys(errors).length == 0) {
            const formData = new FormData();
            formData.append("Type", "Report Document");
            formData.append("FileName", e.target.files[0].name);
            formData.append("File", e.target.files[0]);
            const response = await axios.post(
                '/api/uploaddocument/UploadDocument/', formData,
                {
                    headers: { "Content-type": "multipart/form-data", "FarmId": farmId, "ReferenceId": farmId, "Type": "Report Document", "userId": userId, "FileName": e.target.files[0].name },
                    withCredentials: true
                });

            if (response.data != null) {
                if (response.data.status) {
                    setUploadDocumentName(response.data.content.DocumentName);
                    setUploadDocumentPhysicalFilename(response.data.content.DocumentPhysicalName);
                    setUploadDocumentPhysicalFilepath(response.data.content.DocumentPath);
                    setDocumentDownloadUrl(response.data.content.RelativeFilepath)
                }
                setUploadingDocument(false);
            }
        }
        else {
            setUploadingDocument(false);
            setUploadDocumentPhysicalFilename('');
            setUploadDocumentPhysicalFilepath('');
        }
    }

    const handleItemEditPopup = async (e, itemId) => {
        e.preventDefault();
        var reportDocument = reportDocumentItem.filter(x => x.id == itemId);
        if (reportDocument.length > 0) {
            setReportDate(getDateFromString(moment(reportDocument[0].uploadDate).format("DD/MM/YYYY")));
            if (reportDocument[0].documentPhysicalName != '') {
                setUploadDocumentName(reportDocument[0].documentName);
                setUploadDocumentPhysicalFilename(reportDocument[0].documentPhysicalName);
                setUploadDocumentPhysicalFilepath(reportDocument[0].documentPath);
                setDocumentDownloadUrl(reportDocument[0].documentRelativePath);
            }
            else {
                setUploadDocumentName('');
                setUploadDocumentPhysicalFilename('');
                setUploadDocumentPhysicalFilepath('');
                setDocumentDownloadUrl('');
            }
            if (reportDocument[0].type == 2) {
                var nextCertificationDue = null;
                if (reportDocument[0].nextCertificationDue != null && reportDocument[0].nextCertificationDue != '') {
                    nextCertificationDue = getDateFromString(moment(reportDocument[0].nextCertificationDue).format("DD/MM/YYYY"))
                }
                setReportPopup({
                    ...reportPopup, showReportPopup: true, reportTypePopup: 2, showReportingUser: true,
                    reportingUser: reportDocument[0].username, reportingUserLabel: 'Certifier Name and ID', type: 'Certifier',
                    certificationOutcome: reportDocument[0].certificationOutcome, nextCertificationDue: nextCertificationDue,
                    notePopup: reportDocument[0].notes, id: itemId, noConflictOfIntrest: reportDocument[0].noConflictOfIntrest
                });
            }
            else if (reportDocument[0].type == 3) {
                var nextAuditDue = null;
                if (reportDocument[0].nextAuditDue != null && reportDocument[0].nextAuditDue != '') {
                    nextAuditDue = getDateFromString(moment(reportDocument[0].nextAuditDue).format("DD/MM/YYYY"))
                }
                setReportPopup({
                    ...reportPopup, showReportPopup: true, reportTypePopup: 3, showReportingUser: true,
                    reportingUser: reportDocument[0].username, reportingUserLabel: 'Auditor Name and ID', type: 'Auditor',
                    auditGrade: reportDocument[0].auditGrade, nextAuditDue: nextAuditDue, notePopup: reportDocument[0].notes, id: itemId, noConflictOfIntrest:false
                });
            }
            else if (reportDocument[0].type == 1) {
                setReportPopup({ ...reportPopup, showReportPopup: true, id: itemId, reportTypePopup: 1, notePopup: '', showReportingUser: false, reportingUser: '', reportingUserLabel: '', noConflictOfIntrest: false });
            }
        }
    }
    const getDateFromString = (date) => {
        var dd = date.split('/')[0];
        var mm = date.split('/')[1];
        var yyyy = date.split('/')[2];
        var newDate = new Date(parseInt(yyyy), parseInt(mm) - 1, parseInt(dd));
        return newDate;
    }
    const getDateFromString1 = (date) => {
        var dd = date.split('-')[0];
        var mm = date.split('-')[1];
        var yyyy = date.split('-')[2];
        var newDate = new Date(parseInt(yyyy), parseInt(mm) - 1, parseInt(dd));
        return newDate;
    }
    function handleItemDeletePopup(e,itemId) {
        e.preventDefault();
        setItemDeletePopup({ showItemDeletePopup: true, itemId: itemId });
    }
    function handleItemDeletePopupClose() {
        setItemDeletePopup({ showItemDeletePopup: false, itemId: 0 });
    }
    function handleAutouploadPopupModalClose() {
        setAutoUploadPopupModal({ showAutoUploadPopup: false});
    }
    const handleAutouploadPopupModalYes = async (event) => {
        setAutoUploadPopupModal({ showAutoUploadPopup: false });
        await exportAutoUploadToPdf();
    }
    function handleAutouploadPopupModalOpen() {
        setAutoUploadPopupModal({ showAutoUploadPopup: true });
    }
    const deleteItem = async (event) => {
        const itemid = itemDeletePopup.itemId;
        try {
            const response = await axios.get(
                '/api/summary/DeleteItem/', {
                params: {
                    itemId: itemid, userId: userId
                }
            }
            );
            toast.success("Document deleted!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
            window.location.reload(true);
        } catch (error) {
            console.error('Error:', error);
        }
    }
    const handleCopyToClipboard = async (e) => {
        e.preventDefault();
        navigator.clipboard.writeText(sharePopup.reportRelativePath);
        const response = await axios.get(
            '/api/Summary/ShareReportDocument/', {
            params: { id: sharePopup.id, userId: userId }
        });
        if (response.data.status) {
            toast.success("Shared & Copied to Clipboard!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
            setTimeout(() => {
                window.location.reload(true);
            }, 2000);
        }
    }
    const handleSendEmail = async (e) => {
        e.preventDefault();
        setSending(true);
        let form = {
            Id: sharePopup.itemId,
            EmailAddress: sharePopup.EmailAddress, UserId: userId
        }
        if (!Validate(form)) {
            try {
                const response = await axios.post(
                    '/api/summary/SendEmail/', JSON.stringify(form),
                    {
                        headers: { 'Content-Type': 'application/json' },
                        withCredentials: true
                    });
                if (response.data != null) {
                    if (response.data.status) {
                        toast.success("Email Sent!", { duration: 3000, style: { border: '1px solid #B6D137', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#B6D137', secondary: '#FFFAEE', } });
                        window.location.reload(true);
                    }
                    else {
                        setSending(false);
                        toast.error("Error while sending email!", { duration: 3000, style: { border: '1px solid #f76054', padding: '16px', color: 'black', fontSize: "18px" }, iconTheme: { primary: '#E82300', secondary: '#FFFAEE', } });
                    }

                }
            } catch (error) {
                console.error('Error:', error);
            }
        }
        else {
            setSending(false);
        }
    }
    const getParsedDate = (date) => {
        var dd = date.getDate();
        var mm = date.getMonth() + 1;
        var yyyy = date.getFullYear();
        if (dd < 10) {
            dd = '0' + dd;
        }
        if (mm < 10) {
            mm = '0' + mm;
        }
        date = dd + "-" + mm + "-" + yyyy;
        return date.toString();
    }

    
    const CustomToastWithLink = (message) => (
        <div>
            <p>{message}</p>
        </div>
    );
    const customId = "custom-id-yes";
    const showToastMessage = (e,message) => {
        e.stopPropagation();
        toastytoast.info(CustomToastWithLink(message), {
            autoClose: false, theme: "colored", hideProgressBar: true, icon: false, toastId: customId, rtl: false
        });
    };
    

    const base64ToArrayBuffer = (data) => {
        var binaryString = window.atob(data);
        var binaryLen = binaryString.length;
        var bytes = new Uint8Array(binaryLen);
        for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    }

    

    return (
        <>
            <Card className="my-4">
                <CardHeader className="card-header-dark-click" onClick={toggle}>
                    <Row>
                        <Col sm="11"><h5>Reporting&nbsp;&nbsp;&nbsp;
                            <img className="featureIcon" src="/images/info_button_lt.png" data-tooltip-id="my-tooltip-34" onClick={(e) => e.stopPropagation()} />
                        </h5>
                            <ReactTooltip opacity="1" className="overrideMe" globalCloseEvents={{ escape: true, clickOutsideAnchor: true, scroll: true, resize: true }} openOnClick="true" clickable="true" style={{ marginTop: "-1vh", backgroundColor: "#e2f2f3", color: "black", maxWidth: "25vw", fontWeight: "750", wordBreak: 'normal', overflowWrap: 'break-word' }}
                                id="my-tooltip-34"
                                place="top"
                                variant="info"
                                render={({ content, activeAnchor }) => (
                                    <>
                                        <Row>
                                            <Col>
                                                <p style={{ fontWeight: "lighter" }}>
                                                    For more information on reports and how to download them <a href="https://freshwaterfarmplan.co.nz/support-category/reports/" target="_blank" rel="noreferrer">Click Here</a>
                                                </p>
                                            </Col>
                                        </Row>
                                    </>
                                )}
                            />
                        </Col>
                        <Col sm="1" className="toggleoutline">{isIconUp ? <FaChevronUp /> : <FaChevronDown />}</Col>
                    </Row>
                </CardHeader>
                <Collapse isOpen={isOpen} style={{ backgroundColor: "#0d535d" }}> 
                    <CardBody>
                        <Row>
                            <Col sm="3">
                                <Row>
                                    <Col sm="12">
                                        <img height="90%" width="70%" className="audit-report-img img-responsive" src="images/FarmEnvironmentPlans.jpg" />
                                    </Col>
                                </Row>
                            </Col>
                            <Col sm="9">
                                <Row>
                                    <Col sm="12">
                                        <Label className="form-label-default" style={{ color:"white" }}>
                                            Create a PDF report of your Fresh Water Farm Plan
                                        </Label>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col sm="8">
                                        {/*<Input type="checkbox" checked={fepOnly} onChange={(e) => handleSetFEPOnly(e)} name="fepOnly" id="fepOnly" />&nbsp;&nbsp;&nbsp;*/}
                                        {/*{showEnvironmentSouthland && <Label style={{ color: "white" }}>FEMP Only</Label>}*/}
                                        {/*{!showEnvironmentSouthland && <Label style={{ color: "white" }}>FEP Only</Label>}*/}
                                        <Input type="select" className="float-end" onChange={handleReportTypeChange}
                                            name="reportType1" id="reportType1" value={reportType1}>
                                            <option key={1} value="FWFP" >FreshWater Farm Plan <br/>(regulatory)</option>
                                            <option key={2} value="FEP" >Farm Environment Plan <br />(regulatory)</option>
                                            <option key={3} value="Condensed" >Farm Plan <br />(condensed)</option>
                                        </Input>
                                    </Col>
                                    <Col sm="4">
                                        {reportButtonVisible && <>
                                            {generateReport ?
                                                <Button id="btnSave" onClick={exportSummaryToPdf}
                                                    color="success"
                                                    disabled
                                                >
                                                    <Row>
                                                        <Col sm="9">
                                                            <span>
                                                                {' '}Generating
                                                            </span>
                                                        </Col>
                                                        <Col sm="3">
                                                            <Spinner size="sm" style={{ marginRight: "5px" }}>
                                                                Generating...
                                                            </Spinner>
                                                        </Col>
                                                    </Row>
                                                </Button>
                                                :
                                                <Button id="btnSave" onClick={exportSummaryToPdf} color="success">
                                                    Generate Report
                                                </Button>
                                            }
                                        </>}
                                    </Col>
                                </Row>
                                <Row style={{marginTop:"5px"}}>
                                    <Col sm="12">
                                        {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                            <>
                                            {reportButtonVisible && <>
                                                {autoUploadSaving ?
                                                    <Button id="btnSave" onClick={handleAutouploadPopupModalOpen}
                                                        color="primary" size="sm"
                                                        disabled
                                                    >
                                                        <Row>
                                                            <Col sm="9">
                                                                <span>
                                                                    Uploading
                                                                </span>
                                                            </Col>
                                                            <Col sm="3">
                                                                <Spinner size="sm">
                                                                    Uploading..
                                                                </Spinner>
                                                            </Col>
                                                        </Row>
                                                    </Button>
                                                    :
                                                    <Button id="btnSave" onClick={handleAutouploadPopupModalOpen} color="primary" size="sm">
                                                        Save Report
                                                    </Button>
                                                }
                                                </>}
                                                
                                            </>
                                        }
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <br />
                        <Row>
                            <Col sm="12">
                                <Row>
                                    <Col sm="7">
                                        <Label className="text-capitalize" style={{ color: "white", fontSize:"18px" }}>
                                            Report History<br />
                                            <label style={{ color: "white", fontSize: "12px", fontStyle:"italic" }}>
                                                (Only reports dated less than 2 week old can be shared.)
                                            </label>
                                        </Label>
                                    </Col>
                                    <Col sm="5">
                                        {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                            <>
                                                <Button style={{ float: 'right' }} color="success" onClick={handleReportPopupOpen} size="sm">Upload Document</Button>
                                            </>
                                        }
                                    </Col>
                                </Row>
                                <Row style={{ height: '250px', overflowY: 'auto' }}>
                                    <Col sm="12">
                                        {reportDocumentItem.length > 0 ?
                                            <>
                                                <Table className='table' style={{ border: "1px solid white", backgroundColor:"white" }}>
                                                    <thead className="actionListTable_header">
                                                        <tr>
                                                            <th style={{ textAlign: 'left', width: "25%", backgroundColor:"rgba(82, 175, 181, 0.18)" }}> Report Date </th>
                                                            <th style={{ textAlign: 'left', width: "25%", backgroundColor:"rgba(82, 175, 181, 0.18)"  }}> Report Detail  </th>
                                                            <th style={{ textAlign: 'left', width: "10%", backgroundColor:"rgba(82, 175, 181, 0.18)"  }}> View </th>
                                                            <th style={{ textAlign: 'left', width: "10%", backgroundColor:"rgba(82, 175, 181, 0.18)"  }}> Share </th>
                                                            <th style={{ textAlign: 'left', width: "30%", backgroundColor: "rgba(82, 175, 181, 0.18)" }}> Upload / Remove </th>
                                                        </tr>
                                                    </thead>
                                                    <tbody className="actionListTable_body">
                                                        {reportDocumentItem != undefined && reportDocumentItem != null && reportDocumentItem.map(item => (
                                                            <tr key={uuid()}>
                                                                <td style={{ textAlign: 'left' }}>{item.reportDate}</td>
                                                                <td style={{ textAlign: 'left' }}>
                                                                    <div>
                                                                        <Row>
                                                                            <Col><b>{item.typeText}</b>{item.details != null && item.details != "" && <>{' / '}<b>{item.details}</b></>} </Col>
                                                                        </Row>
                                                                        <Row>
                                                                            <Col>{item.notes}</Col>
                                                                        </Row>
                                                                    </div>
                                                                </td>
                                                                <td style={{ textAlign: 'left' }}>
                                                                    <a style={{ background: "none", border: "none" }} value="Export" placeholder="" href={item.documentRelativePath} target='_blank'>
                                                                        <img src="/images/File_icon.png" className="card_icon" ></img>
                                                                    </a>
                                                                </td>
                                                                <td style={{ textAlign: 'left' }}>
                                                                    {item.showShareButton &&
                                                                        <Button style={{ background: "none", border: "none" }} value="Export" placeholder="" onClick={(e) => handleSharePopupOpen(e, item)}>
                                                                            <FaShareAlt size="25" style={{ color: "red" }} />
                                                                        </Button>
                                                                    }
                                                                    {/*{!item.isExpired &&*/}
                                                                    {/*    <Button style={{ background: "none", border: "none" }} value="Export" placeholder="" onClick={(e) => handleSharePopupOpen(e, item)}>*/}
                                                                    {/*        <FaShareAlt size="25" style={{ color: "green" }} />*/}
                                                                    {/*    </Button>*/}
                                                                    {/*}*/}
                                                                </td>
                                                                <td>
                                                                    <button type="button" onClick={(e) => handleItemEditPopup(e, item.id)}
                                                                        id="btnUpdate"
                                                                        className="btn btn-sm btn-success">
                                                                        <FaEdit />
                                                                    </button>&nbsp;&nbsp;&nbsp;
                                                                    {(roleName == 'Admin' || saveRightsForNonItemFieldsAndTables == 'true') &&
                                                                        <>
                                                                            <button type="button" onClick={(e) => handleItemDeletePopup(e, item.id)}
                                                                                id="btnUpdate"
                                                                                className="btn btn-sm btn-danger">
                                                                                <FaTrash />
                                                                            </button>
                                                                        </>
                                                                    }
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            </>    
                                            : <>
                                                <Label style={{ color: "white", fontSize: "14px" }} >
                                                    No reports yet submited
                                                </Label>
                                            </>
                                        }
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </CardBody>
                </Collapse>
            </Card>
            <Modal isOpen={reportPopup.showReportPopup}>
                <ModalHeader toggle={handleReportPopupClose} >Upload Document</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col xs="4">
                            <Label className="form-label-default">
                                Report Date
                            </Label>
                        </Col>
                        <Col xs="8">
                            <FormGroup>
                                <DatePicker style={{ width: `100%` }} selected={reportDate} onChange={(date) => setReportDate(date)}
                                    name="reportDate" dateFormat="dd/MM/yyyy" className="form-control" />
                            </FormGroup>
                            {formErrors.reportDate != undefined &&
                                <p className="errorMessage">{formErrors.reportDate}</p>
                            }
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col xs="4">
                            <Label className="form-label-default">
                                Choose Type
                            </Label>
                        </Col>
                        <Col xs="8">
                            <Input type="select" className="float-end" onChange={handleReportPopupChange} name="reportTypePopup" id="reportTypePopup" value={reportPopup.reportTypePopup}>
                                <option key={1} value={1} >Complete FWFP Report</option>
                                <option key={2} value={2} >Certification</option>
                                <option key={3} value={3} >Audit</option>
                            </Input>
                        </Col>
                    </Row>
                    <br />
                    {reportPopup.showReportingUser && <div>
                        <Row>
                            <Col xs="4">
                                <Label className="form-label-default">
                                    {reportPopup.reportingUserLabel}
                                </Label>
                            </Col>
                            <Col xs="8">
                                <Input type="text" placeholder="Enter..." name="reportingUser" id="reportingUser" value={reportPopup.reportingUser} onChange={handleReportPopupChange} />
                            </Col>
                        </Row>
                        {reportPopup.type == 'Certifier' &&
                            <>
                                <Row style={{ display:"none" }}>
                                    <Col xs="4">
                                        <Label className="form-label-default">
                                            Certification Outcome
                                        </Label>
                                    </Col>
                                    <Col xs="8">
                                        <Input type="select" className="float-end" onChange={handleReportPopupChange} name="certificationOutcome" id="certificationOutcome" value={reportPopup.certificationOutcome}>
                                            <option key={1} value="Certified">Certified</option>
                                            <option key={2} value="Not Certified" >Not Certified</option>
                                        </Input>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs="4">
                                        <Label className="form-label-default">
                                            Next Certification Due
                                        </Label>
                                    </Col>
                                    <Col xs="8">
                                        <DatePicker style={{ width: `100%` }} selected={reportPopup.nextCertificationDue} onChange={(date) => setReportPopup({ ...reportPopup, nextCertificationDue: date })}
                                            name="nextCertificationDue" dateFormat="dd/MM/yyyy" className="form-control" />
                                    </Col>
                                </Row>
                                <Row>
                                    <Col xs="4">
                                        <Label className="form-label-default">
                                            No Conflict of Interest
                                        </Label>
                                    </Col>
                                <Col xs="8">
                                    <input type="checkbox" className="riskmapCheck" id="noConflictOfIntrest" name="noConflictOfIntrest" checked={reportPopup.noConflictOfIntrest}
                                        onChange={handleReportPopupChange} />
                                    </Col>
                                </Row>
                            </>

                        }
                        {reportPopup.type == 'Auditor' &&
                            <>
                                <Row>
                                    <Col xs="4">
                                        <Label className="form-label-default">
                                            Audit Grade
                                        </Label>
                                    </Col>
                                    <Col xs="8">
                                        <Input type="text" placeholder="Enter..." name="auditGrade" id="auditGrade" value={reportPopup.auditGrade} onChange={handleReportPopupChange} />
                                    </Col>
                                </Row>
                                <br />
                                <Row>
                                    <Col xs="4">
                                        <Label className="form-label-default">
                                            Next Audit Due
                                        </Label>
                                    </Col>
                                    <Col xs="8">
                                        <DatePicker style={{ width: `100%` }} selected={reportPopup.nextAuditDue} onChange={(date) => setReportPopup({ ...reportPopup, nextAuditDue: date })}
                                            name="nextAuditDue" dateFormat="dd/MM/yyyy" className="form-control" />
                                    </Col>
                                </Row>
                            </>

                        }
                        <br />
                    </div>}
                    <Row>
                        <Col>
                            <Input type="textarea" placeholder="Type note..." name="notePopup" id="notePopup" value={reportPopup.notePopup} onChange={handleReportPopupChange} />
                        </Col>
                    </Row>
                    <br />
                    <Row>
                        <Col>
                            {documentDownloadUrl && <a href={documentDownloadUrl} target='_blank'>
                                <img src="/images/File_icon.png" className="PDF_icon settings-image-style" ></img> <span >{uploadDocumentName}</span>
                                <br />

                            </a>}
                            <br />
                            {documentDownloadUrl ?
                                <>
                                    {uploadingDocument ?
                                        <Button id="btnUpload" onClick={handleBtnDocumentUploadClick} size="sm"
                                            color="warning"
                                            disabled
                                        >
                                            <Row>
                                                <Col sm="6">
                                                    <span>
                                                        {' '}Please wait uploading
                                                    </span>
                                                </Col>
                                                <Col sm="6">
                                                    <Spinner size="sm">
                                                        Please wait uploading...
                                                    </Spinner>
                                                </Col>
                                            </Row>
                                        </Button>
                                        :
                                        <Button id="btnUpload" size="sm" onClick={handleBtnDocumentUploadClick} color="warning">
                                            <FaUpload /> Modifiy Document
                                        </Button>
                                    }
                                </> :
                                <>
                                    {uploadingDocument ?
                                        <Button id="btnUpload" onClick={handleBtnDocumentUploadClick}
                                            color="success" size="sm"
                                            disabled
                                        >
                                            <Row>
                                                <Col sm="6">
                                                    <span>
                                                        {' '}Please wait uploading
                                                    </span>
                                                </Col>
                                                <Col sm="6">
                                                    <Spinner size="sm">
                                                        Please wait uploading...
                                                    </Spinner>
                                                </Col>
                                            </Row>
                                        </Button>
                                        :
                                        <Button id="btnUpload" onClick={handleBtnDocumentUploadClick} color="success" size="sm">
                                            <FaUpload /> Upload Document
                                        </Button>
                                    }
                                </>}{formErrors.reportFile != undefined &&
                                <p className="errorMessage">{formErrors.reportFile}</p>
                            }
                            <input style={{ display: 'none' }}
                                ref={input => {
                                    inputDocumentFile = input;
                                }}
                                className="fileInput" id="fileUpload" type="file" onChange={handleDocumentChange} />
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    {saving ?
                        <Button style={{ float: `right`, marginLeft: '10px' }} id="btnSave" onClick={handleReportPopupSave}
                            color="success"
                            disabled
                        >
                            <Row>
                                <Col sm="6">
                                    <span>
                                        {' '}Saving
                                    </span>
                                </Col>
                                <Col sm="6">
                                    <Spinner size="sm">
                                        Saving...
                                    </Spinner>
                                </Col>
                            </Row>
                        </Button>
                        :
                        <Button style={{ float: `right`, marginLeft: '10px' }} id="btnSave" onClick={handleReportPopupSave} color="success">
                            Save
                        </Button>
                    }
                    <Button color="danger" style={{ float: 'right' }} onClick={handleReportPopupClose}>Cancel</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={sharePopup.showSharePopup} size="lg" style={{ maxWidth: '700px', width: '100%' }}>
                <ModalHeader toggle={handleSharePopupClose}>Share Document</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col>
                            Copy hyperlink below to allow access to this report file
                            Or type EMAIL to send link to
                        </Col>
                    </Row>
                    <br/>
                    <Row>
                        <Col xs="9">
                            <Input type="text" className="validate" placeholder="Type email address..." name="EmailAddress" id="EmailAddress" value={sharePopup.EmailAddress} onChange={handleSharePopupChange} />
                            <b>Note</b> : Separate multiple email ids with semicolon(;)
                        </Col>
                        <Col xs="3">
                            {sending ?
                                <Button style={{ float: `right`, marginLeft: '10px' }} id="btnSend" onClick={handleSendEmail}
                                    color="success"
                                    disabled
                                >
                                    <Row>
                                        <Col sm="6">
                                            <span>
                                                {' '} Sending
                                            </span>
                                        </Col>
                                        <Col sm="6">
                                            <Spinner size="sm">
                                                Sending...
                                            </Spinner>
                                        </Col>
                                    </Row>
                                </Button>
                                :
                                <Button style={{ float: `right`, marginLeft: '10px' }} id="btnSend" onClick={handleSendEmail} color="success">
                                    Share & Send
                                </Button>
                            }
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button color="success" style={{ float: 'right' }} onClick={handleCopyToClipboard}>Share & Copy to Clipboard</Button>
                    <Button color="warning" style={{ float: 'right' }} onClick={handleUnshare}>Unshare</Button>
                    <Button color="danger" style={{ float: 'right' }} onClick={handleSharePopupClose}>Cancel</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={itemDeletePopup.showItemDeletePopup}>
                <ModalHeader toggle={handleItemDeletePopupClose} >Delete the item</ModalHeader>
                <ModalBody>
                    Do you want to delete the item ?
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={deleteItem}>Yes</Button>
                    <Button color="danger" onClick={handleItemDeletePopupClose}>No</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={autoUploadPopupModal.showAutoUploadPopup}>
                <ModalHeader toggle={handleAutouploadPopupModalClose} >Save Report</ModalHeader>
                <ModalBody>
                    This will generate a copy of the FWFP Summary (Full report) in PDF format and save a copy into the Report History section automatically.
                    This may take a few minutes. Are you sure you wish to continue?
                </ModalBody>
                <ModalFooter>
                    <Button color="primary" onClick={handleAutouploadPopupModalYes}>Yes</Button>
                    <Button color="danger" onClick={handleAutouploadPopupModalClose}>No</Button>
                </ModalFooter>
            </Modal>
            <Modal isOpen={autoUploadPopup.showAutoUploadPopup}>
                <ModalHeader toggle={handleAutoUploadPopupClose} >Auto Upload</ModalHeader>
                <ModalBody>
                    <Row>
                        <Col>
                            <Label className="form-label-default">Thank you. A copy of the Freshwater Farm Plan report will be uploaded overnight. Please check back tomorrow.</Label>
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button style={{ float: `right`, marginLeft: '10px' }} id="btnSave" onClick={handleAutoUploadPopupClose} color="success">
                        Ok
                    </Button>
                    <Button color="danger" style={{ float: 'right' }} onClick={handleAutoUploadPopupClose}>Cancel</Button>
                </ModalFooter>
            </Modal>
            
        </>
        
    )
}
export default Reporting